import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

function TRMIcon({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg width={23} height={22} fill="none" aria-labelledby={titleId} {...props}>
      {title ? (
        <title id={titleId} className="localize-ignore">
          {title}
        </title>
      ) : null}
      <path
        d="M20.246 9.411c-.892 0-1.628.567-1.752 1.573h-4.828c0-.755-.157-1.059-.425-1.458l4.003-4.013c.146.058.304.077.471.077.699 0 1.265-.571 1.265-1.266 0-.695-.566-1.262-1.265-1.262a1.26 1.26 0 00-1.265 1.256c0 .324.126.616.33.839l-3.903 3.88a2.526 2.526 0 00-1.489-.682V3.54a1.763 1.763 0 001.519-1.742c0-.972-.793-1.761-1.772-1.761-.978 0-1.771.789-1.771 1.761 0 .888.66 1.62 1.518 1.742v4.814a2.524 2.524 0 00-1.415.614L5.691 5.215a1.25 1.25 0 00.383-.9c0-.694-.567-1.257-1.266-1.257-.699 0-1.265.563-1.265 1.258a1.262 1.262 0 001.71 1.174l3.87 3.911c-.324.423-.518.828-.518 1.583H3.523c-.123-1.006-.86-1.573-1.751-1.573-.979 0-1.772.758-1.772 1.73 0 .973.793 1.81 1.772 1.81.892 0 1.628-.709 1.75-1.464h5.133c.096.252.327.83.647 1.166L5.653 16.25a1.273 1.273 0 00-.845-.343c-.699 0-1.265.555-1.265 1.25s.566 1.255 1.265 1.255c.7 0 1.266-.566 1.266-1.26 0-.167-.034-.325-.093-.47l3.75-3.73c.336.223.728.368 1.151.41v5.066a1.764 1.764 0 00-1.518 1.741c0 .973.793 1.762 1.771 1.762.979 0 1.772-.789 1.772-1.762 0-.887-.66-1.62-1.519-1.741v-5.066a2.524 2.524 0 001.276-.502l3.87 3.848a1.24 1.24 0 00-.084.441c0 .695.566 1.258 1.265 1.258.7 0 1.266-.563 1.266-1.258 0-.695-.567-1.258-1.266-1.258-.355 0-.674.146-.904.38l-3.776-3.69c.286-.324.49-.842.58-1.094h4.88c.122.755.859 1.447 1.751 1.447.978 0 1.772-.788 1.772-1.761 0-.973-.794-1.762-1.772-1.762z"
        fill="#071C2C"
      />
    </svg>
  );
}

export default TRMIcon;
